import React from "react";
import { makeStyles } from "@material-ui/core";
import Document from "../../types/Document";

interface IProps {
  document: Document;
  index: number;
  selectedDocumentId: string;
  onClick: (document: Document) => void;
}

export default function PacketDocument(props: IProps) {
  const { document, selectedDocumentId, onClick } = props;
  const classes = useStyles();

  return (
    <div className="topic">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          alignItems: "center",
          position: "relative"
        }}
        className={selectedDocumentId === document.documentId ? "selected" : ""}
        onClick={() => {
          onClick(document);
        }}
      >
        <div className="bullet" />
        <div style={{ padding: 15, flex: 1 }}>
          <div className={classes.title}>{document.documentName}</div>
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 16,
    fontWeight: 700
  },
  titleSmall: {
    fontSize: 14,
    marginLeft: 5,
    fontWeight: 400
  },
  subTitle: {
    fontSize: 10,
    marginTop: 5,
    opacity: 0.6
  },
  subTitleSmall: {
    fontSize: 10,
    marginTop: 5,
    marginLeft: 5,
    opacity: 0.6
  }
}));
